module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ka-La.b70703fa.png";